import { type CSSProperties } from 'typestyle/lib/types';
import { type SxProps } from '@mui/material';
import StyleConstants from '../../../core/styles.constants';

export const cardContainer = (
  withOnClick: boolean,
): CSSProperties => ({
  cursor: withOnClick ? 'pointer' : '',
  padding: 16,
  background: StyleConstants.WHITE_COLOR,
  border: '1px solid rgba(36, 55, 75, 0.2)',
  borderRadius: 8,
  transition: 'box-shadow 0.15s ease',
});

export const iconContainer: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 40,
  height: 40,
  borderRadius: 10,
  backgroundColor: 'rgba(38, 69, 156, 0.08)',
  flexShrink: 0,
};

export const iconSx: SxProps = {
  color: StyleConstants.DARK_BLUE_COLOR,
  fontSize: 22,
};

export const nameText: CSSProperties = {
  wordBreak: 'break-word',
  fontSize: StyleConstants.CARD_TITLE_FONT_SIZE,
  fontWeight: StyleConstants.CARD_TITLE_FONT_WEIGHT,
  fontFamily: StyleConstants.PRIMARY_FONT_FAMILY,
  color: StyleConstants.GREY_COLOR,
};

export const chipRow: CSSProperties = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: 6,
  marginTop: 8,
};

export const chip: CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: 4,
  padding: '2px 8px',
  borderRadius: 12,
  backgroundColor: 'rgba(36, 55, 75, 0.06)',
  fontSize: 11,
  fontWeight: StyleConstants.CARD_BODY_FONT_WEIGHT,
  fontFamily: StyleConstants.PRIMARY_FONT_FAMILY,
  color: StyleConstants.GREY_COLOR,
  whiteSpace: 'nowrap',
};

export const chipIconSx: SxProps = {
  fontSize: 13,
  color: StyleConstants.LIGHT_GREY_COLOR,
};
